import React from "react";
import ReactDOM from "react-dom";
import find from "lodash/find";
import mailcheck from "mailcheck";

import "../form/formatBarcode";
import RequestTypeSelect from "./RequestTypeSelect";
import ReasonSelect, { availableReasons } from "./ReasonSelect";

const showField = (field) => {
  field.classList.remove("is-hidden");
};

const hideField = (field) => {
  field.classList.add("is-hidden");
};

const enableField = (field) => {
  field.removeAttribute("disabled");
};

const disableField = (field) => {
  field.setAttribute("disabled", "disabled");
};

const handleReplicationGroupChange = (event) => {
  const options = event.target.options;
  const replicationGroupType = options[options.selectedIndex].dataset.rgType;

  const $barcodeField = document.querySelector(".field.barcode");
  const $licensePlateField = document.querySelector(".field.license_plate");
  const $licensePlateStateField = document.querySelector(".field.license_plate_state");

  const $barcodeInput = document.getElementById("ticket_barcode");
  const $licensePlateInput = document.getElementById("ticket_license_plate");
  const $licensePlateStateInput = document.getElementById("ticket_license_plate_state");

  if (replicationGroupType === "DrbReplicationGroup") {
    showField($barcodeField);
    enableField($barcodeInput);
    hideField($licensePlateField);
    disableField($licensePlateInput);
    hideField($licensePlateStateField);
    disableField($licensePlateStateInput);
  } else if (replicationGroupType === "WashifyReplicationGroup") {
    hideField($barcodeField);
    disableField($barcodeInput);
    showField($licensePlateField);
    enableField($licensePlateInput);
    showField($licensePlateStateField);
    enableField($licensePlateStateInput);
  } else {
    hideField($barcodeField);
    disableField($barcodeInput);
    hideField($licensePlateField);
    disableField($licensePlateInput);
    hideField($licensePlateStateField);
    disableField($licensePlateStateInput);
  }
};

const $replicationGroupDropdown = document.getElementById("ticket_replication_group_id");
if ($replicationGroupDropdown) {
  $replicationGroupDropdown.addEventListener("change", handleReplicationGroupChange);
}

const locations = () => {
  JSON.parse(document.querySelector("#ticket_location_field[data-locations]").dataset.locations);
};

const suggestEmail = ({ target }) => {
  const $help = target.closest(".field").querySelector(".help");

  mailcheck.run({
    email: target.value,
    suggested: function (suggestion) {
      $help.innerHTML = `Did you mean ${suggestion.full}?`;
    },
    empty: function () {
      $help.innerHTML = "";
    },
  });
};

const selectedLocation = (locationId) => {
  return find(locations(), (location) => location.id === parseInt(locationId));
};

const handleLocationChange = ({ target: { value: locationId } }) => {
  displayLocationHelpText(selectedLocation(locationId));
};

const displayLocationHelpText = (location) => {
  document.querySelector("#ticket_location_field .help-text").innerHTML = location
    ? location.ticket_help_text
    : "";
};

const displayRequestTypeHelpText = (requestType) => {
  let helpTextHTML = "";
  if (requestType) {
    helpTextHTML = requestType.help_text_html;
  }
  document.querySelector("#ticket_request_type_field .help-text").innerHTML = helpTextHTML;
};

const displayReasonSelect = ({ code } = {}) => {
  const $reasonField = document.querySelector("#ticket_reason_field");

  if (Object.keys(availableReasons).indexOf(code) > -1) {
    $reasonField.classList.remove("is-hidden");
  } else {
    $reasonField.classList.add("is-hidden");
  }
};

const redirect = ({
  redirect_url: url,
  open_redirect_url_in_new_window: open_in_new_window,
} = {}) => {
  if (!url) return;

  if (open_in_new_window === false) {
    window.top.location.href = url;
    return;
  }

  window.open(url);
};

const handleRequestTypeSelected = (requestType) => {
  displayRequestTypeHelpText(requestType);
  displayReasonSelect(requestType);
  redirect(requestType);
};

document.querySelector("#ticket_email").addEventListener("blur", suggestEmail);

const $locationId = document.querySelector("#ticket_location_id");
if ($locationId) {
  $locationId.addEventListener("change", handleLocationChange);
  displayLocationHelpText(selectedLocation($locationId.value));
}

ReactDOM.render(
  <RequestTypeSelect onRequestTypeSelected={handleRequestTypeSelected} />,
  document.querySelector("#ticket_request_type_field .select")
);

ReactDOM.render(<ReasonSelect />, document.querySelector("#ticket_reason_field .select"));
